:host {
  height: fit-content;
}
